import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useAuthenticationStageStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    height: '100px',
  },
  title: {
    marginTop: '32px',
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '32px',
    color: tokens.colorNeutralForeground1,
  },
  description: {
    maxWidth: '420px',
    fontSize: tokens.fontSizeBase400,
    lineHeight: '21px',
    color: tokens.colorNeutralForeground2,
  },
  helpLink: {
    marginLeft: '4px',
  },
  itemsContainer: {
    maxWidth: '408px',
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
    marginTop: '32px',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
  item: {
    display: 'flex',
    alignItems: 'center',
  },
  checkmark: {
    color: tokens.colorPaletteSeafoamForeground2,
    fontSize: tokens.fontSizeBase600,
    marginRight: '8px',
  },
  itemText: {
    fontSize: tokens.fontSizeBase400,
    color: tokens.colorNeutralForeground2,
  },
  actionsContainer: {
    marginTop: '32px',
    display: 'flex',
    ...shorthands.gap(tokens.spacingVerticalS),
  },
});
